import { TransactionChartType } from '@pt/models';

export const COLORS = {
  [TransactionChartType.Income]: [
    'var(--color-donut-2)',
    'var(--color-donut-3)',
    'var(--color-donut-5)',
    'var(--color-donut-4)',
    'var(--color-donut-1)',
  ],
  [TransactionChartType.Expense]: [
    'var(--color-donut-1)',
    'var(--color-donut-4)',
    'var(--color-donut-5)',
    'var(--color-donut-2)',
    'var(--color-donut-2)',
  ],
  [TransactionChartType.IncomeExpense]: [
    'var(--color-donut-2)',
    'var(--color-donut-1)',
    'var(--color-donut-5)',
    'var(--color-donut-4)',
    'var(--color-donut-3)',
  ],
  [TransactionChartType.ReceivedSent]: [
    'var(--color-donut-3)',
    'var(--color-donut-4)',
    'var(--color-donut-2)',
    'var(--color-donut-5)',
    'var(--color-donut-1)',
  ],
  [TransactionChartType.ReceivedBurned]: [
    'var(--color-donut-2)',
    'var(--color-donut-1)',
    'var(--color-donut-5)',
    'var(--color-donut-4)',
    'var(--color-donut-3)',
  ],
};
